import React, { useEffect, useMemo, useRef, useState, Suspense } from "react";
import { useApolloClient, useQuery } from "@apollo/client";
import { useLocation, useNavigate } from "react-router-dom";
import MainLayout from "../../components/buttonUi/MainLayout";
import { loadingComponent } from "../../modules/Maps/Map/utils";
import { useTranslation } from "../index";
import EnhancedCameraBox from "src/newComponents/EnhancedCameraBox";
import FlvPlayer from "./components/FlvPlayer";
import CameraPlaceholder from "src/newComponents/CameraPlaceholder";
import CameraLayoutPicker from "../../components/CameraLayoutPicker";
import DashcamFilters from "../../components/DashcamFilters";
import { useDevices } from "src/newComponents/dashboard/useDevices";
import VehicleList from "src/modules/TrackingControls/components/vehicleList";

import { GET_ALL_DEVICES } from "../../modules/graphql/queries";
import { GET_VEHICLE_DETAILS } from "../../common/queries/trackingControls";
// Import des ic?nes
import {
  MdDirectionsCar,
  MdSearch,
  MdClose,
  MdKeyboardArrowDown,
  MdKeyboardArrowUp,
  MdFullscreen,
  MdLocationOn,
  MdPhone,
} from "react-icons/md";
import { IoCameraSharp, IoVideocam, IoPersonSharp } from "react-icons/io5";
import { FaCircle, FaTruck, FaBolt, FaChartLine, FaClock, FaDigg, FaBullseye, FaCompressAlt, FaMapMarkerAlt, FaThLarge, FaDesktop } from "react-icons/fa";
import { GiBulldozer, GiRoad, GiNeedleDrill, GiTankTread } from "react-icons/gi";
import { MdFrontLoader } from "react-icons/md";
import greenTruckIcon from "../../modules/static/png/green_truck.png";
import grayTruckIcon from "../../modules/static/png/gray_truck.png";
import greenCarIcon from "../../modules/static/png/green_car.png";
import grayCarIcon from "../../modules/static/png/gray_car.png";
import { gql } from "@apollo/client";

const SEND_COMMAND_DASHCAM = gql`
  mutation SendCommandDashcam($imei: String!, $command: String!) {
    sendCommandDashcam(imei: $imei, command: $command) {
      success
      message
    }
  }
`;

const DEFAULT_REPLAY_VIDEO_URL =
  "https://dev.ftp.lewootrack.com/media/42353664a236d1d892bbcbf6155d4900/102_64_6404_3_42353664a236d1d892bbcbf6155d4900.mp4";

const resolveReplayVideoUrl = (rawUrl) => {
  if (!rawUrl) return "";

  if (typeof window === "undefined") {
    return rawUrl;
  }

  try {
    const resolvedUrl = new URL(rawUrl, window.location.origin);

    // Avoid mixed-content blocking when the app is served over HTTPS.
    if (window.location.protocol === "https:" && resolvedUrl.protocol === "http:") {
      resolvedUrl.protocol = "https:";
    }

    return resolvedUrl.toString();
  } catch (error) {
    console.warn("Invalid replay URL:", rawUrl, error);
    return "";
  }
};

export const DashcamPageContent = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const isDashcamV2Route = String(location.pathname || "").toLowerCase().includes("/dashcam-v2");
  const apolloClient = useApolloClient();
  const { data: trackingVehiclesData } = useQuery(GET_ALL_DEVICES, {
    variables: { filters: { isAst: true } },
    fetchPolicy: "cache-first",
    skip: isDashcamV2Route,
  });
  const { devices: trackingVehiclesDataV2 = [] } = useDevices({
    useV2: isDashcamV2Route,
    filters: isDashcamV2Route ? { isAst: true } : undefined,
  });

  const [selectedVehicle, setSelectedVehicle] = useState({});
  const [isChangeModalOpen, setIsChangeModalOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [fullscreenVehicle, setFullscreenVehicle] = useState(null);
  const [isControlRoomModalOpen, setIsControlRoomModalOpen] = useState(false);
  const [isDigitalControlRoomOpen, setIsDigitalControlRoomOpen] = useState(false);
  const [digitalScreenConfigs, setDigitalScreenConfigs] = useState({
    screen1: [],
    screen2: [],
    screen3: [],
    screen4: []
  });
  const [vehicleLayouts, setVehicleLayouts] = useState({});

  // (Garde l??T?tat si tu veux le r?utiliser plus tard)
  const [cameraLayout, setCameraLayout] = useState(2);

  const [isLive, setIsLive] = useState(false);
  const [isReplay, setIsReplay] = useState(true);
  const replayVideoUrl = useMemo(
    () =>
      resolveReplayVideoUrl(
        process.env.REACT_APP_DASHCAM_REPLAY_URL || DEFAULT_REPLAY_VIDEO_URL
      ),
    []
  );
  const replayAvailable = Boolean(replayVideoUrl);

  // ??tats pour le filtre et les m?triques
  const [showFilters, setShowFilters] = useState(false);
  const [selectedZoneIndex, setSelectedZoneIndex] = useState(0);
  const [selectedVehicleTypes, setSelectedVehicleTypes] = useState(["all"]);
  const [deviceSidebarFilter, setDeviceSidebarFilter] = useState("all");
  const [activeSidebarVehicleId, setActiveSidebarVehicleId] = useState(null);
  const [sidebarSearchQuery, setSidebarSearchQuery] = useState("");
  const [sidebarPage, setSidebarPage] = useState(1);
  const [dashcamV2VisibleVehicles, setDashcamV2VisibleVehicles] = useState(null);
  const [talkPopoverState, setTalkPopoverState] = useState(null);
  const [isLocationPopoverOpen, setIsLocationPopoverOpen] = useState(false);
  const [isLocationModalOpen, setIsLocationModalOpen] = useState(false);
  const [talkElapsedSeconds, setTalkElapsedSeconds] = useState(0);
  const [talkErrorMessage, setTalkErrorMessage] = useState("Connection failed");
  const [talkSimCard, setTalkSimCard] = useState("");
  const [talkChannel, setTalkChannel] = useState("1");
  const [talkWsUrl, setTalkWsUrl] = useState("wss://das.lewootrack.com/intercom");
  const [talkPacketCount, setTalkPacketCount] = useState(0);
  const [talkRecvCount, setTalkRecvCount] = useState(0);
  const [talkWsState, setTalkWsState] = useState("Disconnected");
  const [talkMicState, setTalkMicState] = useState("-");
  const [talkSampleRate, setTalkSampleRate] = useState("-");
  const [talkRealLevel, setTalkRealLevel] = useState(0);
  const [talkStatusMessage, setTalkStatusMessage] = useState("Inactive");
  const [talkLogs, setTalkLogs] = useState([]);
  const [streamImeiMap, setStreamImeiMap] = useState({});
  const wsRef = useRef(null);
  const audioCtxRef = useRef(null);
  const sourceRef = useRef(null);
  const processorRef = useRef(null);
  const streamRef = useRef(null);
  const talkReadyTimeoutRef = useRef(null);
  const isCameraReadyRef = useRef(false);
  const playbackAudioCtxRef = useRef(null);
  const playbackQueueRef = useRef([]);
  const playbackActiveRef = useRef(false);
  const requestedImeiVehiclesRef = useRef(new Set());
  const rawTrackingDevices = useMemo(
    () => (isDashcamV2Route ? trackingVehiclesDataV2 : trackingVehiclesData?.devices || []),
    [isDashcamV2Route, trackingVehiclesData?.devices, trackingVehiclesDataV2]
  );

  // Donn?es pour les filtres et m?triques
  const trackingVehicles = useMemo(() => {
    const devices = Array.isArray(rawTrackingDevices)
      ? [...rawTrackingDevices]
      : [];

    return devices
      .sort((a, b) => (b?.timestamp ?? 0) - (a?.timestamp ?? 0))
      .map((vehicle) => {
        const fallbackStreamId = String(vehicle?.uniqueId || "")
          .replace(/^it_/i, "")
          .trim();
        const streamId = String(
          streamImeiMap[vehicle?.vehicleNumber] || fallbackStreamId
        ).trim();

        const cameras = {
          pairCount: 1,
          channels: [
            {
              title: "CH-1 Front",
              videoSrc: streamId ? `https://das.lewootrack.com/video/${streamId}-1` : "",
              isLive: true,
            },
            {
              title: "CH-2 Back",
              videoSrc: streamId ? `https://das.lewootrack.com/video/${streamId}-2` : "",
              isLive: true,
            },
          ],
        };

        return {
          id: vehicle?.uniqueId,
          uniqueId: vehicle?.uniqueId,
          vehicleNumber: vehicle?.vehicleNumber || vehicle?.uniqueId || "-",
          plate: vehicle?.vehicleNumber || "-",
          name: vehicle?.vehicleType || vehicle?.vehicleModel || "",
          vehicleName: vehicle?.vehicleNumber || vehicle?.vehicleType || "Vehicle",
          imei: vehicle?.uniqueId || "",
          clientName: vehicle?.clientName || "",
          clientKey: vehicle?.clientKey,
          clientLoginId: vehicle?.clientLoginId,
          vehicleGroups: vehicle?.vehicleGroups || [],
          timestamp: vehicle?.timestamp,
          isOffline: Boolean(vehicle?.isOffline),
          isNoGps: Boolean(vehicle?.isNoGps),
          vehicleType: vehicle?.vehicleType,
          vehicleModel: vehicle?.vehicleModel,
          model_name: vehicle?.model_name,
          address: vehicle?.address || "",
          cameras: 2,
          camerasData: cameras,
          online: !vehicle?.isOffline,
          lastLocation: vehicle?.address || "",
          latitude: vehicle?.latitude,
          longitude: vehicle?.longitude,
          haltStatus: vehicle?.haltStatus,
          idlingStatus: vehicle?.idlingStatus,
          speed: vehicle?.speed,
        };
      });
  }, [rawTrackingDevices, streamImeiMap]);

  useEffect(() => {
    const devices = Array.isArray(rawTrackingDevices)
      ? rawTrackingDevices
      : [];
    const vehicleNumbersToFetch = devices
      .map((vehicle) => vehicle?.vehicleNumber)
      .filter(
        (vehicleNumber) =>
          vehicleNumber &&
          !streamImeiMap[vehicleNumber] &&
          !requestedImeiVehiclesRef.current.has(vehicleNumber)
      );

    if (vehicleNumbersToFetch.length === 0) return;

    vehicleNumbersToFetch.forEach((vehicleNumber) => {
      requestedImeiVehiclesRef.current.add(vehicleNumber);
    });

    let isCancelled = false;

    Promise.allSettled(
      vehicleNumbersToFetch.map((vehicleNumber) =>
        apolloClient.query({
          query: GET_VEHICLE_DETAILS,
          variables: { vehicleNumber },
          fetchPolicy: "network-only",
        })
      )
    ).then((results) => {
      if (isCancelled) return;

      const nextEntries = {};
      results.forEach((result, index) => {
        if (result.status !== "fulfilled") return;
        const vehicleNumber = vehicleNumbersToFetch[index];
        const imeiNum = result.value?.data?.getVehicleDetail?.device?.imei_num;
        if (imeiNum) {
          nextEntries[vehicleNumber] = String(imeiNum).trim();
        }
      });

      if (Object.keys(nextEntries).length > 0) {
        setStreamImeiMap((current) => ({ ...current, ...nextEntries }));
      }
    });

    return () => {
      isCancelled = true;
    };
  }, [apolloClient, rawTrackingDevices, streamImeiMap]);

  // Donnees pour les filtres et metriques
  const zones = useMemo(() => {
    const loadingQueue = trackingVehicles.filter(
      (vehicle) => !vehicle.online || vehicle.haltStatus
    );
    const toDP = trackingVehicles.filter(
      (vehicle) => vehicle.online && vehicle.idlingStatus
    );
    const movingToLoad = trackingVehicles.filter(
      (vehicle) =>
        vehicle.online &&
        !vehicle.haltStatus &&
        !vehicle.idlingStatus &&
        Number(vehicle.speed || 0) > 0
    );
    const assignedVehicleIds = new Set([
      ...loadingQueue.map((vehicle) => vehicle.id),
      ...toDP.map((vehicle) => vehicle.id),
      ...movingToLoad.map((vehicle) => vehicle.id),
    ]);
    const unclassifiedVehicles = trackingVehicles.filter(
      (vehicle) => !assignedVehicleIds.has(vehicle.id)
    );

    return [
      {
        name: "Overview",
        activeCount: trackingVehicles.length,
        loadingQueue: [...loadingQueue, ...unclassifiedVehicles].map((vehicle) => ({ ...vehicle, cameras: vehicle.camerasData })),
        toDP: toDP.map((vehicle) => ({ ...vehicle, cameras: vehicle.camerasData })),
        movingToLoad: movingToLoad.map((vehicle) => ({ ...vehicle, cameras: vehicle.camerasData })),
        efficiency:
          trackingVehicles.length > 0
            ? Math.round(
                (trackingVehicles.filter((vehicle) => vehicle.online).length /
                  trackingVehicles.length) *
                  100
              )
            : 0,
      },
    ];
  }, [trackingVehicles]);
  const vehicleTypes = [
    { id: "all", label: t("LEWOOMINING.label.overview"), icon: FaBullseye, color: "text-gray-700" },
    { id: "excavator", label: t("LEWOOMINING.label.excavator"), icon: FaDigg, color: "text-blue-700" },
    { id: "truck", label: t("LEWOOMINING.label.truck"), icon: FaTruck, color: "text-green-700" },
    { id: "bulldozer", label: t("LEWOOMINING.label.bulldozer"), icon: GiBulldozer, color: "text-orange-700" },
    { id: "drill", label: t("LEWOOMINING.label.drill"), icon: GiNeedleDrill, color: "text-red-700" },
    { id: "loader", label: t("LEWOOMINING.label.loader"), icon: MdFrontLoader, color: "text-purple-700" },
    { id: "grader", label: t("LEWOOMINING.label.grader"), icon: GiRoad, color: "text-indigo-700" },
    { id: "tanker", label: t("LEWOOMINING.label.tanker"), icon: GiTankTread, color: "text-teal-700" },
    { id: "compactor", label: t("LEWOOMINING.label.compactor"), icon: FaCompressAlt, color: "text-amber-700" },
  ];

  const selectedZone = zones[selectedZoneIndex] || zones[0];

  const metrics = [
    {
      label: t("LEWOOMINING.label.queue"),
      value: selectedZone.loadingQueue.length.toString(),
      icon: <FaClock className="text-blue-600" />,
      color: "bg-blue-50",
      progress: selectedZone.loadingQueue.length / 30,
    },
    {
      label: t("LEWOOMINING.label.loading"),
      value: selectedZone.toDP.length.toString(),
      icon: <FaBolt className="text-green-600" />,
      color: "bg-green-50",
      progress: selectedZone.toDP.length / 20,
    },
    {
      label: t("LEWOOMINING.label.in_transit"),
      value: selectedZone.movingToLoad.length.toString(),
      icon: <FaChartLine className="text-blue-600" />,
      color: "bg-blue-50",
      progress: selectedZone.movingToLoad.length / 25,
    },
    {
      label: t("LEWOOMINING.label.un_loading"),
      value: `${selectedZone.efficiency}%`,
      icon: <FaChartLine className="text-orange-600" />,
      color: "bg-orange-50",
      progress: selectedZone.efficiency / 100,
    },
    { label: t("LEWOOMINING.label.return_base"), value: "92%", icon: <FaChartLine className="text-orange-600" />, color: "bg-orange-50", progress: 0.92 },
    { label: t("LEWOOMINING.label.maintainance"), value: "92%", icon: <FaChartLine className="text-orange-600" />, color: "bg-orange-50", progress: 0.92 },
  ];

  const toggleVehicleType = (typeId) => {
    if (typeId === "all") {
      setSelectedVehicleTypes(["all"]);
      return;
    }

    let newSelection = [...selectedVehicleTypes];

    if (newSelection.includes("all")) newSelection = newSelection.filter((id) => id !== "all");

    if (newSelection.includes(typeId)) {
      newSelection = newSelection.filter((id) => id !== typeId);
      if (newSelection.length === 0) newSelection = ["all"];
    } else {
      newSelection.push(typeId);
    }

    setSelectedVehicleTypes(newSelection);
  };

  const filteredVehicles = trackingVehicles.filter((v) =>
    [v.plate, v.imei, v.name, v.vehicleName]
      .filter(Boolean)
      .some((value) =>
        String(value).toLowerCase().includes(searchQuery.toLowerCase())
      )
  );

  const normalizeDeviceRef = (value) =>
    String(value || "")
      .trim()
      .toLowerCase()
      .replace(/^it_/i, "");

  const requestedDeviceRef = useMemo(() => {
    const params = new URLSearchParams(location.search || "");
    return params.get("device");
  }, [location.search]);

  useEffect(() => {
    if (!requestedDeviceRef) return;

    const requested = normalizeDeviceRef(requestedDeviceRef);
    if (!requested) return;

    const matchedVehicle = trackingVehicles.find((vehicle) => {
      const candidates = [
        vehicle?.id,
        vehicle?.uniqueId,
        vehicle?.imei,
        vehicle?.plate,
      ];

      return candidates.some(
        (candidate) => normalizeDeviceRef(candidate) === requested
      );
    });

    if (!matchedVehicle) return;

    const matchedSidebarId =
      matchedVehicle.id || matchedVehicle.imei || matchedVehicle.plate;

    if (deviceSidebarFilter !== "all") {
      setDeviceSidebarFilter("all");
    }

    if (sidebarSearchQuery) {
      setSidebarSearchQuery("");
    }

    if (activeSidebarVehicleId !== matchedSidebarId) {
      setActiveSidebarVehicleId(matchedSidebarId);
    }

    const selectedRef = normalizeDeviceRef(
      selectedVehicle?.imei || selectedVehicle?.id || selectedVehicle?.plate
    );
    if (selectedRef !== requested) {
      setSelectedVehicle({
        ...matchedVehicle,
        cameras: matchedVehicle.camerasData,
      });
    }
  }, [
    requestedDeviceRef,
    trackingVehicles,
    deviceSidebarFilter,
    sidebarSearchQuery,
    activeSidebarVehicleId,
    selectedVehicle,
  ]);

  useEffect(() => {
    if (requestedDeviceRef && activeSidebarVehicleId) return;
    if (!selectedVehicle?.imei && trackingVehicles.length > 0) {
      setSelectedVehicle({ ...trackingVehicles[0], cameras: trackingVehicles[0].camerasData });
    }
  }, [trackingVehicles, selectedVehicle?.imei, requestedDeviceRef, activeSidebarVehicleId]);
  const handleVehicleSelect = (vehicle) => {
    setSelectedVehicle({ ...vehicle, cameras: vehicle.camerasData });
    setIsChangeModalOpen(false);
    setSearchQuery("");
  };
  const handleDashcamVehicleListSelection = (vehicle) => {
    if (!vehicle) {
      setActiveSidebarVehicleId(null);
      return;
    }

    const vehicleId = vehicle.id || vehicle.uniqueId || vehicle.imei || vehicle.plate;
    setActiveSidebarVehicleId(vehicleId);
    setSelectedVehicle({ ...vehicle, cameras: vehicle.camerasData });
  };
  const buildLiveChannel = (videoSrc, title, vehicleKey) => ({
    id: `${vehicleKey}-${title}`,
    url: videoSrc,
    isPlaying: true,
    isMuted: true,
  });
  const handleVehicleCardClick = (vehicle) => {
    if (!isLive || !vehicle) return;
    setActiveSidebarVehicleId(vehicle.id || vehicle.imei || vehicle.plate);
  };

  const getDashcamCommandImei = (vehicleLike) =>
    String(vehicleLike?.uniqueId || vehicleLike?.imei || vehicleLike?.id || "")
      .replace(/^it_/i, "")
      .trim();

  const sendDashcamStreamingCommand = async (vehicleLike, command) => {
    const imei = getDashcamCommandImei(vehicleLike);
    if (!imei) {
      return {
        success: false,
        message: "IMEI introuvable",
      };
    }

    try {
      const response = await apolloClient.mutate({
        mutation: SEND_COMMAND_DASHCAM,
        variables: {
          imei,
          command,
        },
      });

      return response?.data?.sendCommandDashcam || {
        success: false,
        message: "Commande dashcam indisponible",
      };
    } catch (error) {
      console.error("sendCommandDashcam failed", error);
      return {
        success: false,
        message: error?.message || "Erreur lors de l'envoi de la commande dashcam",
      };
    }
  };

  const activateDashcamLive = async () => {
    const liveVehicle = selectedVehicle?.uniqueId ? selectedVehicle : trackingVehicles[0];
    const commandResult = await sendDashcamStreamingCommand(
      liveVehicle,
      "streaming,156.67.105.172,1078"
    );

    if (!commandResult?.success) {
      window.alert(commandResult?.message || "Impossible d'activer le live");
      return;
    }

    setIsLive(true);
    setIsReplay(false);
  };


  const renderCameraContent = ({ title, videoSrc, vehicleKey, allowLive = false }) => {
    if (isLive) {
      if (!videoSrc) {
        return <CameraPlaceholder title={title} />;
      }

      if (!allowLive) {
        return (
          <div className="flex h-full min-h-[220px] items-center justify-center rounded-lg border border-dashed border-gray-300 bg-gray-50 p-6 text-center">
            <div>
              <div className="text-sm font-semibold text-gray-700">Live disponible sur le vehicule selectionne</div>
              <div className="mt-2 text-xs text-gray-500">Selectionnez ce vehicule pour ouvrir son flux en direct.</div>
              <div className="mt-3 text-xs font-medium text-gray-400">{title}</div>
            </div>
          </div>
        );
      }

      return (
        <FlvPlayer
          channel={buildLiveChannel(videoSrc, title, vehicleKey)}
          width="100%"
          height="100%"
          isEnabled={true}
        />
      );
    }

    if (isReplay && replayAvailable) {
      return (
        <EnhancedCameraBox
          title={title}
          videoSrc={replayVideoUrl}
          isLive={false}
          isReplay={true}
        />
      );
    }

    return videoSrc ? (
      <EnhancedCameraBox
        title={title}
        videoSrc={videoSrc}
        isLive={true}
        isReplay={false}
      />
    ) : (
      <CameraPlaceholder title={title} />
    );
  };


  // Fonction pour ouvrir la salle de contr?le num?rique
  const openDigitalControlRoom = () => {
    // Utiliser l'?tat actuel des configurations d'?cran
    const currentConfigs = digitalScreenConfigs;

    // R?cup?rer tous les v?hicules de la zone s?lectionn?e
    const allVehiclesInZone = [
      ...(selectedZone?.loadingQueue || []),
      ...(selectedZone?.toDP || []),
      ...(selectedZone?.movingToLoad || []),
    ];

    // V?rifier s'il y a des configurations d'?cran avec des v?hicules assign?s
    const screensWithVehicles = Object.entries(currentConfigs).map(([screen, vehicleIds]) => {
      // Trouver les objets v?hicule complets bas?s sur les IDs dans la configuration
      const vehicles = vehicleIds
        .map(id => allVehiclesInZone.find(vehicle => vehicle.id === id))
        .filter(vehicle => vehicle); // Supprimer les undefined

      console.log(`??cran ${screen}: ${vehicleIds.length} IDs configur?s, ${vehicles.length} v?hicules trouv?s`);

      return [screen, vehicles];
    }).filter(([screen, vehicles]) => vehicles.length > 0);

    console.log(`Nombre total d'?crans avec v?hicules: ${screensWithVehicles.length}`);
    console.log(`??crans avec v?hicules:`, screensWithVehicles);

    if (screensWithVehicles.length === 0) {
      // Si aucune configuration n'existe, utiliser la logique par d?faut
      const vehiclesInZone = [
        ...(selectedZone?.loadingQueue || []),
        ...(selectedZone?.toDP || []),
        ...(selectedZone?.movingToLoad || []),
      ];

      // Diviser les v?hicules en groupes de 4 pour simuler diff?rents ?crans
      const vehicleGroups = [];
      for (let i = 0; i < vehiclesInZone.length; i += 4) {
        vehicleGroups.push(vehiclesInZone.slice(i, i + 4));
      }

      // Pour chaque groupe de v?hicules, ouvrir une fen?tre
      vehicleGroups.forEach((group, index) => {
        // Cr?er une cha?ne de requ?te avec les IDs des v?hicules
        const vehicleIds = group.map(v => v.id || v.imei || v.plate).join(',');

        // Ouvrir une nouvelle fen?tre pour ce groupe
        const windowFeatures = 'width=1200,height=800,left=' + (index * 50) + ',top=' + (index * 50);
        window.open(`/mine/dashcam/digital-control-room?vehicles=${vehicleIds}&group=${index}`, `_blank${index}`, windowFeatures);
      });
    } else {
      // Ouvrir une fen?tre pour chaque ?cran configur? qui a des v?hicules assign?s
      screensWithVehicles.forEach(([screen, vehicles], index) => {
        // Cr?er une cha?ne de requ?te avec les IDs des v?hicules pour cet ?cran
        const vehicleIds = vehicles.map(v => v.id || v.imei || v.plate).join(',');

        // Ouvrir une nouvelle fen?tre pour cet ?cran
        const windowFeatures = 'width=1200,height=800,left=' + (index * 50) + ',top=' + (index * 50);
        window.open(`/mine/dashcam/digital-control-room?vehicles=${vehicleIds}&screen=${screen}`, `_blank${index}`, windowFeatures);
      });
    }
  };

  // ?o. Liste des v?hicules visibles (zone s?lectionn?e)
  const vehiclesInZone = [
    ...(selectedZone?.loadingQueue || []),
    ...(selectedZone?.toDP || []),
    ...(selectedZone?.movingToLoad || []),
  ];

  const sidebarCounters = {
    all: vehiclesInZone.length,
    online: vehiclesInZone.filter((vehicle) => vehicle.online).length,
    offline: vehiclesInZone.filter((vehicle) => !vehicle.online).length,
  };

  const sidebarVehicles = vehiclesInZone.filter((vehicle) => {
    if (deviceSidebarFilter === "online") return vehicle.online;
    if (deviceSidebarFilter === "offline") return !vehicle.online;
    return true;
  });

  const normalizedSidebarSearch = sidebarSearchQuery.trim().toLowerCase();

  const searchedSidebarVehicles = sidebarVehicles.filter((vehicle) => {
    if (!normalizedSidebarSearch) return true;

    return [
      vehicle.plate,
      vehicle.imei,
      vehicle.vehicleName,
      vehicle.driver,
      vehicle.lastLocation,
    ]
      .filter(Boolean)
      .some((value) => String(value).toLowerCase().includes(normalizedSidebarSearch));
  });

  const sidebarItemsPerPage = 5;
  const sidebarTotalPages = Math.max(1, Math.ceil(searchedSidebarVehicles.length / sidebarItemsPerPage));
  const safeSidebarPage = Math.min(sidebarPage, sidebarTotalPages);
  const paginatedSidebarVehicles = searchedSidebarVehicles.slice(
    (safeSidebarPage - 1) * sidebarItemsPerPage,
    safeSidebarPage * sidebarItemsPerPage
  );
  const dashcamV2SidebarVehicles =
    isDashcamV2Route && Array.isArray(dashcamV2VisibleVehicles)
      ? dashcamV2VisibleVehicles
      : searchedSidebarVehicles;

  const selectedSidebarVehicles = activeSidebarVehicleId
    ? trackingVehicles.filter((vehicle) => (vehicle.id || vehicle.imei || vehicle.plate) === activeSidebarVehicleId)
    : [];

  const isSingleVehicleFocus = selectedSidebarVehicles.length === 1;
  const displayedVehicles = selectedSidebarVehicles.length > 0 ? selectedSidebarVehicles : dashcamV2SidebarVehicles;

  const focusedVehicle = isSingleVehicleFocus ? selectedSidebarVehicles[0] : null;

  const cameraLayoutOptions = [
    { id: 1, preview: [[1]] },
    { id: 2, preview: [[1, 1]] },
    { id: 4, preview: [[1, 1], [1, 1]] },
    { id: 6, preview: [[1, 1], [1, 1], [0.45, 0.45]] },
    { id: 8, preview: [[1, 1], [1, 1], [1, 1], [0.45, 0.45]] },
    { id: 16, preview: [[1, 1, 1, 1], [1, 1, 1, 1], [1, 1, 1, 1], [1, 1, 1, 1]] },
  ];

  const getLayoutPreviewClass = (layoutId) => {
    if (layoutId === 1) return "grid grid-cols-1";
    if (layoutId === 2) return "grid grid-cols-2 gap-[2px]";
    if (layoutId === 4) return "grid grid-cols-2 gap-[2px]";
    if (layoutId === 6) return "grid grid-cols-2 gap-[2px]";
    if (layoutId === 8) return "grid grid-cols-2 gap-[2px]";
    return "grid grid-cols-4 gap-[1px]";
  };

  const buildFocusedLayoutSlots = (vehicle, layoutId) => {
    const channels = vehicle?.cameras?.channels || [];
    const count = Number(layoutId) || 2;

    return Array.from({ length: count }).map((_, index) => ({
      key: `${vehicle?.id || vehicle?.imei || vehicle?.plate || "vehicle"}-${layoutId}-${index}`,
      channel: channels[index] || null,
      title: channels[index]?.title || `CH-${index + 1}`,
    }));
  };

  const getRenderableFocusedSlots = (vehicle, layoutId) => {
    const slots = buildFocusedLayoutSlots(vehicle, layoutId);

    if (!isLive) return slots;

    const liveSlots = slots.filter((slot) => slot.channel?.videoSrc);
    return liveSlots.length > 0 ? liveSlots : slots.slice(0, 1);
  };

  const getFocusedLayoutWrapperClass = (layoutId) => {
    if (layoutId === 1) return "grid grid-cols-1 gap-3 min-h-0";
    if (layoutId === 2) return "grid grid-cols-1 lg:grid-cols-2 gap-3 min-h-0";
    if (layoutId === 4) return "grid grid-cols-1 md:grid-cols-2 gap-3 min-h-0";
    if (layoutId === 6) return "grid grid-cols-1 xl:grid-cols-3 gap-3 min-h-0";
    if (layoutId === 8) return "grid grid-cols-1 xl:grid-cols-4 gap-3 min-h-0";
    return "grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-3 min-h-0";
  };

  const getFocusedLayoutItemClass = (layoutId, index) => {
    if (layoutId === 1) return "aspect-[16/9]";
    if (layoutId === 2) return "aspect-[16/9]";
    if (layoutId === 4) return "aspect-[16/9]";
    if (layoutId === 6) {
      if (index === 0) return "aspect-[16/9] xl:col-span-2 xl:row-span-2";
      if (index === 1) return "aspect-[16/9] xl:col-start-3 xl:row-start-1";
      if (index === 2) return "aspect-[16/9] xl:col-start-3 xl:row-start-2";
      if (index === 3) return "aspect-[16/9] xl:col-start-1 xl:row-start-3";
      if (index === 4) return "aspect-[16/9] xl:col-start-2 xl:row-start-3";
      return "aspect-[16/9] xl:col-start-3 xl:row-start-3";
    }
    if (layoutId === 8) {
      if (index === 0) return "aspect-[16/9] xl:col-span-3 xl:row-span-3";
      if (index === 1) return "aspect-[16/9] xl:col-start-4 xl:row-start-1";
      if (index === 2) return "aspect-[16/9] xl:col-start-4 xl:row-start-2";
      if (index === 3) return "aspect-[16/9] xl:col-start-4 xl:row-start-3";
      if (index === 4) return "aspect-[16/9] xl:col-start-1 xl:row-start-4";
      if (index === 5) return "aspect-[16/9] xl:col-start-2 xl:row-start-4";
      if (index === 6) return "aspect-[16/9] xl:col-start-3 xl:row-start-4";
      return "aspect-[16/9] xl:col-start-4 xl:row-start-4";
    }
    return "aspect-[16/9]";
  };

  const getVehicleMarkerIcon = (vehicle) => {
    const descriptor = `${vehicle?.vehicleName || ""} ${vehicle?.plate || ""}`.toLowerCase();
    const looksHeavyVehicle =
      descriptor.includes("truck") ||
      descriptor.includes("loader") ||
      descriptor.includes("bulldozer") ||
      descriptor.includes("drill") ||
      descriptor.includes("tanker") ||
      descriptor.includes("compactor");

    if (looksHeavyVehicle) {
      return vehicle?.online ? greenTruckIcon : grayTruckIcon;
    }

    return vehicle?.online ? greenCarIcon : grayCarIcon;
  };

  const locationCoordinateMap = {
    "zone a - entrance": { lat: 4.0511, lng: 9.7679 },
    "zone b - loading area": { lat: 4.0484, lng: 9.7608 },
    "zone c - dump point": { lat: 4.0427, lng: 9.7746 },
    "zone d - moving to load": { lat: 4.0578, lng: 9.7812 },
    "zone 1 - excavation site": { lat: 4.0641, lng: 9.7921 },
    "zone 1 - dump point": { lat: 4.0613, lng: 9.7853 },
    "zone 1 - moving to load": { lat: 4.0587, lng: 9.7896 },
    "zone 2 - loading area": { lat: 4.0711, lng: 9.7984 },
    "zone 2 - dump point": { lat: 4.0751, lng: 9.8045 },
    "zone 2 - moving to load": { lat: 4.0675, lng: 9.8098 },
    "zone 3 - loading area": { lat: 4.0794, lng: 9.8162 },
    "zone 3 - dump point": { lat: 4.0841, lng: 9.8216 },
    "zone 4 - excavation site": { lat: 4.0892, lng: 9.8281 },
    "zone 4 - dump point": { lat: 4.0937, lng: 9.8335 },
    "zone 5 - drilling site": { lat: 4.0989, lng: 9.8407 },
    "zone 5 - compaction area": { lat: 4.1022, lng: 9.8461 },
  };

  const getVehicleCoordinates = (vehicle) => {
    if (!vehicle) return { lat: 4.0511, lng: 9.7679 };

    if (typeof vehicle.latitude === "number" && typeof vehicle.longitude === "number") {
      return { lat: vehicle.latitude, lng: vehicle.longitude };
    }

    const key = String(vehicle.lastLocation || "").toLowerCase();
    return locationCoordinateMap[key] || { lat: 4.0511, lng: 9.7679 };
  };

  const getVehicleLocationMapUrl = (vehicle, zoom = 17) => {
    const { lat, lng } = getVehicleCoordinates(vehicle);
    return `https://www.google.com/maps?q=${lat},${lng}&z=${zoom}&output=embed`;
  };

  const formatTalkDuration = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${String(minutes).padStart(2, "0")}:${String(remainingSeconds).padStart(2, "0")}`;
  };

  const clearTalkReadyTimeout = () => {
    if (talkReadyTimeoutRef.current) {
      window.clearTimeout(talkReadyTimeoutRef.current);
      talkReadyTimeoutRef.current = null;
    }
  };

  const addTalkLog = (message, type = "info") => {
    const entry = {
      id: `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
      message,
      type,
      timestamp: new Date().toLocaleTimeString(),
    };

    setTalkLogs((current) => [entry, ...current].slice(0, 100));
  };

  const processTalkPlaybackQueue = async () => {
    if (playbackQueueRef.current.length === 0) {
      playbackActiveRef.current = false;
      return;
    }

    playbackActiveRef.current = true;
    const chunk = playbackQueueRef.current.shift();

    try {
      const AudioContextCtor = window.AudioContext || window.webkitAudioContext;
      const playbackContext = playbackAudioCtxRef.current || new AudioContextCtor();
      playbackAudioCtxRef.current = playbackContext;

      if (playbackContext.state === "suspended") {
        await playbackContext.resume();
      }

      const audioBuffer = await playbackContext.decodeAudioData(chunk.slice(0));
      const source = playbackContext.createBufferSource();
      source.buffer = audioBuffer;
      source.connect(playbackContext.destination);
      source.onended = () => processTalkPlaybackQueue();
      source.start();
    } catch (error) {
      console.error("AAC decode error", error);
      addTalkLog(`AAC decode error: ${error?.message || error}`, "error");
      processTalkPlaybackQueue();
    }
  };

  const playTalkAacChunk = async (aacData) => {
    if (!aacData || aacData.byteLength === 0) return;

    setTalkRecvCount((count) => count + 1);
    playbackQueueRef.current.push(aacData);

    if (!playbackActiveRef.current) {
      await processTalkPlaybackQueue();
    }
  };

  const cleanupTalkResources = () => {
    clearTalkReadyTimeout();
    isCameraReadyRef.current = false;
    playbackQueueRef.current = [];
    playbackActiveRef.current = false;

    if (processorRef.current) {
      processorRef.current.disconnect();
      processorRef.current.onaudioprocess = null;
      processorRef.current = null;
    }

    if (sourceRef.current) {
      sourceRef.current.disconnect();
      sourceRef.current = null;
    }

    if (audioCtxRef.current) {
      audioCtxRef.current.close().catch(() => {});
      audioCtxRef.current = null;
    }

    if (streamRef.current) {
      streamRef.current.getTracks().forEach((track) => track.stop());
      streamRef.current = null;
    }

    if (wsRef.current) {
      try {
        wsRef.current.onopen = null;
        wsRef.current.onmessage = null;
        wsRef.current.onerror = null;
        wsRef.current.onclose = null;
        wsRef.current.close();
      } catch (error) {
        console.error("Unable to close intercom websocket", error);
      }
      wsRef.current = null;
    }

    if (playbackAudioCtxRef.current) {
      playbackAudioCtxRef.current.close().catch(() => {});
      playbackAudioCtxRef.current = null;
    }

    setTalkWsState("Disconnected");
    setTalkMicState("Inactive");
    setTalkSampleRate("-");
    setTalkRealLevel(0);
  };

  const failTalkIntercom = (message = "Connection failed") => {
    cleanupTalkResources();
    setTalkElapsedSeconds(0);
    setTalkErrorMessage(message);
    setTalkStatusMessage(message);
    addTalkLog(message, "error");
    setTalkPopoverState("failed");
  };

  const stopTalkIntercom = () => {
    addTalkLog(`Stopped. Sent ${talkPacketCount} packets, received ${talkRecvCount}`, "info");
    cleanupTalkResources();
    setTalkElapsedSeconds(0);
    setTalkStatusMessage("Stopped");
    setTalkPopoverState(null);
  };

  const startTalkIntercom = async () => {
    if (!focusedVehicle || typeof window === "undefined" || !navigator?.mediaDevices?.getUserMedia) {
      setTalkErrorMessage("Intercom unavailable");
      setTalkPopoverState("failed");
      return;
    }

    cleanupTalkResources();
    setTalkElapsedSeconds(0);
    setTalkErrorMessage("Connection failed");
    setTalkPacketCount(0);
    setTalkRecvCount(0);
    setTalkLogs([]);
    setTalkStatusMessage("Connecting...");
    setTalkPopoverState("connecting");

    try {
      const commandResult = await sendDashcamStreamingCommand(
        focusedVehicle,
        "streaming,156.67.105.172,1079"
      );

      if (!commandResult?.success) {
        failTalkIntercom(commandResult?.message || "Commande talk refusee");
        return;
      }

      const sim = String(talkSimCard || focusedVehicle?.imei || focusedVehicle?.plate || "").trim();
      const channel = Number.parseInt(String(talkChannel || "1"), 10) || 1;
      const ws = new WebSocket(talkWsUrl);
      ws.binaryType = "arraybuffer";
      wsRef.current = ws;
      addTalkLog(`Starting intercom for ${sim}-${channel}`, "info");

      ws.onopen = () => {
        setTalkWsState("Connected");
        setTalkStatusMessage("Connected - waiting for camera...");
        addTalkLog("WebSocket connected", "success");
        ws.send(JSON.stringify({ sim, channel, timestamp: Date.now() }));
        addTalkLog(`Metadata sent: ${sim}-${channel}`, "info");
      };

      ws.onmessage = (event) => {
        if (event.data instanceof ArrayBuffer) {
          playTalkAacChunk(event.data);
          return;
        }

        if (typeof event.data !== "string") return;

        try {
          const response = JSON.parse(event.data);
          addTalkLog(`Server response: ${response.status}`, "info");

          if (response.status === "ok" || response.status === "connected") {
            clearTalkReadyTimeout();
            isCameraReadyRef.current = true;
            setTalkStatusMessage("Camera ready - speak now");
            addTalkLog("Camera ready - you can speak", "success");
            setTalkPopoverState("active");
            return;
          }

          if (response.status === "pending") {
            setTalkStatusMessage("Waiting for camera...");
            return;
          }

          if (response.status === "error") {
            failTalkIntercom(response.message || "Connection failed");
          }
        } catch (error) {
          console.error("Intercom response parse error", error);
          addTalkLog(`Response parse error: ${error?.message || error}`, "error");
        }
      };

      ws.onerror = () => {
        setTalkWsState("Error");
        failTalkIntercom("WebSocket error");
      };
      ws.onclose = () => {
        setTalkWsState("Closed");
        if (isCameraReadyRef.current || talkPopoverState === "active" || talkPopoverState === "connecting") {
          failTalkIntercom("Connection failed");
        }
      };

      addTalkLog("Requesting microphone access...", "info");
      const mediaStream = await navigator.mediaDevices.getUserMedia({
        audio: {
          echoCancellation: true,
          noiseSuppression: true,
          autoGainControl: false,
          sampleRate: 8000
        },
      });

      streamRef.current = mediaStream;
      setTalkMicState("Active");
      addTalkLog("Microphone ready", "success");

      const AudioContextCtor = window.AudioContext || window.webkitAudioContext;
      const audioCtx = new AudioContextCtor({ sampleRate: 8000 });
      audioCtxRef.current = audioCtx;
      setTalkSampleRate(audioCtx.sampleRate);

      const source = audioCtx.createMediaStreamSource(mediaStream);
      sourceRef.current = source;

      const processor = audioCtx.createScriptProcessor(256, 1, 1);
      processorRef.current = processor;

      source.connect(processor);
      processor.connect(audioCtx.destination);
      await audioCtx.resume();
      addTalkLog("Audio pipeline started (buffer 256)", "success");

      processor.onaudioprocess = (event) => {
        const input = event.inputBuffer.getChannelData(0);
        let realMax = 0;
        let prevInput = 0;
        let prevOutput = 0;
        const alpha = 0.93;
        const noiseThreshold = 0.01;
        const buffer = new ArrayBuffer(input.length * 2);
        const view = new DataView(buffer);

        for (let index = 0; index < input.length; index += 1) {
          const sample = input[index];
          const amplitude = Math.abs(sample);
          if (amplitude > realMax) realMax = amplitude;

          let filtered = sample - prevInput + alpha * prevOutput;
          prevInput = sample;
          prevOutput = filtered;

          if (Math.abs(filtered) < noiseThreshold) {
            filtered = 0;
          }

          const pcm = filtered < 0 ? filtered * 0x8000 : filtered * 0x7fff;
          view.setInt16(index * 2, pcm, true);
        }

        setTalkRealLevel(realMax);

        if (!wsRef.current || wsRef.current.readyState !== WebSocket.OPEN || !isCameraReadyRef.current) {
          return;
        }

        try {
          wsRef.current.send(buffer);
          setTalkPacketCount((count) => {
            const nextCount = count + 1;
            if (nextCount % 50 === 0) {
              addTalkLog(`Sent #${nextCount} (${buffer.byteLength} bytes)`, "success");
            }
            return nextCount;
          });
        } catch (error) {
          addTalkLog(`Send error: ${error?.message || error}`, "error");
        }
      };

      talkReadyTimeoutRef.current = window.setTimeout(() => {
        if (!isCameraReadyRef.current) {
          failTalkIntercom("Connection timeout");
        }
      }, 10000);

      document.body.addEventListener(
        "click",
        () => {
          if (playbackAudioCtxRef.current?.state === "suspended") {
            playbackAudioCtxRef.current.resume().catch(() => {});
          }
        },
        { once: true }
      );
    } catch (error) {
      console.error("Intercom start error", error);
      failTalkIntercom(error?.message || "Unable to start intercom");
    }
  };

  useEffect(() => {
    if (talkPopoverState !== "active") return undefined;

    const intervalId = window.setInterval(() => {
      setTalkElapsedSeconds((seconds) => seconds + 1);
    }, 1000);

    return () => window.clearInterval(intervalId);
  }, [talkPopoverState]);

  useEffect(() => () => {
    cleanupTalkResources();
  }, []);

  const focusedVehicleKey = focusedVehicle?.id || focusedVehicle?.imei || focusedVehicle?.plate || null;

  useEffect(() => {
    if (!focusedVehicle) return;

    setTalkSimCard(String(focusedVehicle.imei || focusedVehicle.plate || "").replace(/^it_/i, ""));
    setTalkChannel("1");
    setTalkWsUrl("ws://bi.lewootrack.com:6005");
    setIsLocationPopoverOpen(false);
  }, [focusedVehicleKey]);

  useEffect(() => {
    setSidebarPage(1);
  }, [deviceSidebarFilter, sidebarSearchQuery, selectedZoneIndex]);

  useEffect(() => {
    if (sidebarPage > sidebarTotalPages) {
      setSidebarPage(sidebarTotalPages);
    }
  }, [sidebarPage, sidebarTotalPages]);

  // ?o. Helper: r?cup?rer front/back (robuste)
  const getChannelByType = (vehicle, type) => {
    const channels = vehicle?.cameras?.channels || [];
    if (type === "front") return channels.find((c) => /front/i.test(c.title)) || channels[0] || null;
    if (type === "back") return channels.find((c) => /back/i.test(c.title)) || channels[1] || null;
    return null;
  };
  return (
    <>
      <Suspense fallback={loadingComponent}>
        <div className="flex min-h-screen flex-col bg-gray-50">
          {/* Header */}
          <div className="bg-white border-b border-gray-200">
            <div className="flex flex-col">
              {/* Ligne 1 - Titre et ic?ne */}
              <div className="flex items-center justify-between border-b border-gray-200 px-5 py-4">
                <div className="flex items-center gap-4">
                  <div className="w-10 h-10 bg-[#E0F7F5] rounded-lg flex items-center justify-center">
                    <IoVideocam className="text-[#00B8A9] w-5 h-5" />
                  </div>
                  <div>
                    <h1 className="font-bold text-gray-800 text-xl leading-tight">
                      Dashcam Viewer
                      {selectedVehicle && selectedVehicle.plate && (
                        <span className="text-blue-600 text-base font-medium ml-2">??? {selectedVehicle.plate}</span>
                      )}
                    </h1>
                    <p className="text-xs text-gray-500 mt-0.5">{t("LEWOOMINING.viewLiveAndReplayStreams")}</p>
                  </div>
                </div>
              </div>

              {/* Ligne 2 - Contr?les */}
              <div className="px-5 pb-4">
                <div className="flex items-center justify-end gap-2 flex-wrap rounded-xl px-2 py-2">
                
                  {/* (Optionnel) Layout picker ??" n??Timpacte plus la grille vehicle */}
                  {/* <CameraLayoutPicker cameraLayout={cameraLayout} setCameraLayout={setCameraLayout} /> */}


                  <div className="flex items-center justify-end gap-2 lg:justify-self-end">
                      <button
                        type="button"
                        className="rounded-md bg-[#13c2c2] px-3 py-1.5 text-sm font-medium text-white hover:bg-[#13c2c2] transition"
                      >
                        Start All
                      </button>
                      <button
                        type="button"
                        className="rounded-md border border-gray-300 bg-white px-3 py-1.5 text-sm font-medium text-gray-500 hover:bg-gray-50 transition"
                      >
                        Stop All
                      </button>

                     
                    </div>

                  {/* Live/Replay */}
                  <div className="flex items-center gap-2">
                    <label className="flex items-center gap-1">
                      <input
                        type="radio"
                        name="viewMode"
                        checked={isLive}
                        onChange={activateDashcamLive}
                        className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-[#13c2c2]"
                      />
                      <span className="text-xs font-medium">Live</span>
                    </label>

                    <label className="flex items-center gap-1">
                      <input
                        type="radio"
                        name="viewMode"
                        checked={isReplay && replayAvailable}
                        onChange={() => {
                          if (!replayAvailable) return;
                          setIsReplay(true);
                          setIsLive(false);
                        }}
                        disabled={!replayAvailable}
                        className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-[#13c2c2] disabled:opacity-40 disabled:cursor-not-allowed"
                      />
                      <span className="text-xs font-medium">Replay{!replayAvailable ? " indisponible" : ""}</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Filtres */}
          {showFilters && (
            <div className="mb-6 transition-all duration-300 ease-in-out">
              <DashcamFilters
                zones={zones}
                selectedZoneIndex={selectedZoneIndex}
                setSelectedZoneIndex={setSelectedZoneIndex}
                vehicleTypes={vehicleTypes}
                selectedVehicleTypes={selectedVehicleTypes}
                toggleVehicleType={toggleVehicleType}
                metrics={metrics}
              />
            </div>
          )}

          {/* ?o. Sidebar devices + grille des v?hicules */}
          <div className="px-5 py-3">
            <div className="flex flex-col gap-4 xl:flex-row">
              {isDashcamV2Route ? (
                <div className="w-full shrink-0 xl:w-[370px] xl:max-w-[370px]">
                  <VehicleList
                    vehicles={vehiclesInZone}
                    selectedVehicle={selectedVehicle?.uniqueId ? selectedVehicle : null}
                    selectedVehicleIds={selectedVehicle?.uniqueId ? [selectedVehicle.uniqueId] : []}
                    onSelectedVehicleChange={handleDashcamVehicleListSelection}
                    onVisibleVehiclesChange={setDashcamV2VisibleVehicles}
                    designVariant="groups-panel"
                    showVehicleActions={false}
                  />
                </div>
              ) : (
                <aside className="w-full shrink-0 overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-sm xl:w-[320px] xl:max-w-[320px]">
                  <div className="border-b border-gray-200 px-4 py-4">
                    <div className="flex items-center gap-2">
                      <div className="flex h-9 w-9 items-center justify-center rounded-xl bg-[#E0F7F5]">
                        <FaMapMarkerAlt className="text-[#00B8A9]" />
                      </div>
                      <div>
                        <h3 className="text-sm font-semibold text-gray-900">Device Location</h3>
                        <p className="text-xs text-gray-500">{selectedZone?.name || "Overview"}</p>
                      </div>
                    </div>
                  </div>

                  <div className="border-b border-gray-100 px-3 py-3">
                    <div className="grid grid-cols-3 gap-2">
                      {[
                        { id: "all", label: "All", count: sidebarCounters.all },
                        { id: "online", label: "Online", count: sidebarCounters.online },
                        { id: "offline", label: "Offline", count: sidebarCounters.offline },
                      ].map((filter) => {
                        const isActive = deviceSidebarFilter === filter.id;

                        return (
                          <button
                            key={filter.id}
                            type="button"
                            onClick={() => {
                              setDeviceSidebarFilter(filter.id);
                              setActiveSidebarVehicleId(null);
                            }}
                            className={`rounded-xl border px-3 py-2 text-left transition ${
                              isActive
                                ? "border-[#00B8A9] bg-[#E0F7F5] text-[#00796B]"
                                : "border-gray-200 bg-gray-50 text-gray-600 hover:bg-gray-100"
                            }`}
                          >
                            <div className="text-sm font-semibold">{filter.label}</div>
                            <div className="text-xs">{filter.count}</div>
                          </button>
                        );
                      })}
                    </div>
                  </div>

                  <div className="border-b border-gray-100 px-3 py-3">
                    <div className="relative">
                      <MdSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-base text-gray-400" />
                      <input
                        type="text"
                        value={sidebarSearchQuery}
                        onChange={(event) => setSidebarSearchQuery(event.target.value)}
                        placeholder="Search device..."
                        className="w-full rounded-xl border border-gray-200 bg-gray-50 py-2 pl-10 pr-3 text-sm text-gray-700 outline-none focus:border-[#00B8A9] focus:bg-white"
                      />
                    </div>
                  </div>

                  <div>
                    <div className="border-b border-gray-100 px-4 py-3 text-xs font-semibold uppercase tracking-wide text-gray-400">
                      Default Group ({searchedSidebarVehicles.length})
                    </div>

                    {paginatedSidebarVehicles.length === 0 ? (
                      <div className="px-4 py-6 text-sm text-gray-500">Aucun device pour ce filtre.</div>
                    ) : (
                      paginatedSidebarVehicles.map((vehicle) => {
                        const vehicleId = vehicle.id || vehicle.imei || vehicle.plate;
                        const isActive = activeSidebarVehicleId === vehicleId;

                        return (
                          <button
                            key={vehicleId}
                            type="button"
                            onClick={() =>
                              setActiveSidebarVehicleId((current) => (current === vehicleId ? null : vehicleId))
                            }
                            className={`flex w-full items-start gap-3 border-b border-gray-100 px-4 py-3 text-left transition hover:bg-gray-50 ${
                              isActive ? "bg-[#E0F7F5]/70" : ""
                            }`}
                          >
                            <span className="mt-1 h-2.5 w-2.5 rounded-full bg-gray-200" />
                            <div className="min-w-0 flex-1">
                              <div className="flex items-center justify-between gap-2">
                                <span className="truncate text-sm font-semibold text-gray-900">
                                  {vehicle.plate || vehicle.imei}
                                </span>
                                <FaCircle
                                  className={`shrink-0 text-[10px] ${
                                    vehicle.online ? "text-green-500" : "text-gray-300"
                                  }`}
                                />
                              </div>
                              <div className="truncate text-xs text-gray-500">
                                {vehicle.vehicleName || vehicle.driver || "Device"}
                              </div>
                              <div className="mt-1 flex items-start gap-1 text-xs text-gray-500">
                                <FaMapMarkerAlt className="mt-0.5 shrink-0 text-[10px] text-[#00B8A9]" />
                                <span>{vehicle.lastLocation || "Location inconnue"}</span>
                              </div>
                            </div>
                          </button>
                        );
                      })
                    )}
                  </div>

                  <div className="border-t border-gray-100 px-3 py-3">
                    <div className="flex items-center justify-between gap-2 text-xs text-gray-500">
                      <span>
                        Page {safeSidebarPage}/{sidebarTotalPages}
                      </span>
                      <div className="flex items-center gap-2">
                        <button
                          type="button"
                          onClick={() => setSidebarPage((page) => Math.max(1, page - 1))}
                          disabled={safeSidebarPage === 1}
                          className="rounded-md border border-gray-200 px-2 py-1 disabled:cursor-not-allowed disabled:opacity-40"
                        >
                          Prev
                        </button>
                        <button
                          type="button"
                          onClick={() => setSidebarPage((page) => Math.min(sidebarTotalPages, page + 1))}
                          disabled={safeSidebarPage === sidebarTotalPages}
                          className="rounded-md border border-gray-200 px-2 py-1 disabled:cursor-not-allowed disabled:opacity-40"
                        >
                          Next
                        </button>
                      </div>
                    </div>
                  </div>
                </aside>
              )}

              <div className="flex-1">
                {isLive && !isSingleVehicleFocus && (
                  <div className="mb-4 rounded-2xl border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-900 shadow-sm">
                    Le live est ouvert uniquement pour un vehicule a la fois. Selectionnez un vehicule dans la liste de gauche pour afficher son flux en direct.
                  </div>
                )}

                {isSingleVehicleFocus && focusedVehicle && (
                  <div className="mb-4 grid grid-cols-1 items-center gap-3 rounded-2xl border border-gray-200 bg-white px-4 py-3 shadow-sm lg:grid-cols-[minmax(220px,1fr)_auto_minmax(220px,1fr)]">
                    <div className="min-w-0">
                      <div className="truncate text-sm font-semibold text-gray-900">
                        {focusedVehicle.vehicleName || "Vehicle"} {focusedVehicle.plate ? `� ${focusedVehicle.plate}` : ""}
                      </div>
                      <div className="truncate text-xs text-gray-500">
                        {focusedVehicle.lastLocation || "Location inconnue"}
                      </div>
                    </div>

                    <div className="flex items-center justify-center lg:justify-self-center">
                      <div className="flex items-center gap-1 rounded-lg border border-[#d7dce5] bg-white p-1">
                      {cameraLayoutOptions.map((option) => {
                        const isActive = cameraLayout === option.id;

                        return (
                          <button
                            key={option.id}
                            type="button"
                            onClick={() => setCameraLayout(option.id)}
                            className={`flex h-7 min-w-[34px] items-center justify-center rounded-md px-1.5 transition ${
                              isActive ? "bg-[#4b8df8]" : "bg-white hover:bg-gray-50"
                            }`}
                            aria-label={`Disposition ${option.id}`}
                            title={`Disposition ${option.id}`}
                          >
                            <span className={getLayoutPreviewClass(option.id)}>
                              {option.id === 1 && (
                                <span className={`h-4 w-6 rounded-[3px] ${isActive ? "bg-white" : "bg-[#98a1ad]"}`} />
                              )}

                              {option.id === 2 && (
                                <>
                                  <span className={`h-4 w-[9px] rounded-[2px] ${isActive ? "bg-white" : "bg-[#98a1ad]"}`} />
                                  <span className={`h-4 w-[9px] rounded-[2px] ${isActive ? "bg-white" : "bg-[#98a1ad]"}`} />
                                </>
                              )}

                              {option.id === 4 && (
                                <>
                                  {Array.from({ length: 4 }).map((_, index) => (
                                    <span
                                      key={index}
                                      className={`h-[6px] w-[9px] rounded-[2px] ${isActive ? "bg-white" : "bg-[#98a1ad]"}`}
                                    />
                                  ))}
                                </>
                              )}

                              {option.id === 6 && (
                                <>
                                  <span className={`h-[6px] w-[9px] rounded-[2px] ${isActive ? "bg-white" : "bg-[#98a1ad]"}`} />
                                  <span className={`h-[6px] w-[9px] rounded-[2px] ${isActive ? "bg-white" : "bg-[#98a1ad]"}`} />
                                  <span className={`h-[6px] w-[9px] rounded-[2px] ${isActive ? "bg-white" : "bg-[#98a1ad]"}`} />
                                  <span className={`h-[6px] w-[9px] rounded-[2px] ${isActive ? "bg-white" : "bg-[#98a1ad]"}`} />
                                  <span className={`h-[2px] w-[4px] rounded-[1px] ${isActive ? "bg-white" : "bg-[#98a1ad]"}`} />
                                  <span className={`h-[2px] w-[4px] rounded-[1px] ${isActive ? "bg-white" : "bg-[#98a1ad]"}`} />
                                </>
                              )}

                              {option.id === 8 && (
                                <>
                                  {Array.from({ length: 6 }).map((_, index) => (
                                    <span
                                      key={index}
                                      className={`h-[5px] w-[8px] rounded-[2px] ${isActive ? "bg-white" : "bg-[#98a1ad]"}`}
                                    />
                                  ))}
                                  <span className={`h-[2px] w-[4px] rounded-[1px] ${isActive ? "bg-white" : "bg-[#98a1ad]"}`} />
                                  <span className={`h-[2px] w-[4px] rounded-[1px] ${isActive ? "bg-white" : "bg-[#98a1ad]"}`} />
                                </>
                              )}

                              {option.id === 16 && (
                                <>
                                  {Array.from({ length: 16 }).map((_, index) => (
                                    <span
                                      key={index}
                                      className={`h-[3px] w-[3px] rounded-[1px] ${isActive ? "bg-white" : "bg-[#98a1ad]"}`}
                                    />
                                  ))}
                                </>
                              )}
                            </span>
                          </button>
                        );
                      })}
                      </div>
                    </div>

                    <div className="flex items-center justify-end gap-2 lg:justify-self-end">
                     
                      <div className="relative">
                        <button
                          type="button"
                          onClick={() =>
                            setTalkPopoverState((current) => (current ? null : "confirm"))
                          }
                          className="inline-flex items-center gap-1 rounded-md px-2 py-1.5 text-sm font-medium text-gray-500 hover:bg-gray-50 transition"
                        >
                          <MdPhone className="text-base" />
                          Talk
                        </button>

                        {talkPopoverState === "confirm" && (
                          <div className="absolute right-0 top-full z-[9999] mt-2 w-[360px] rounded-xl bg-[#171717] p-4 text-white shadow-xl">
                            <div className="absolute -top-2 right-[4%] h-0 w-0 border-l-8 border-r-8 border-b-8 border-l-transparent border-r-transparent border-b-[#171717]" />
                            <div className="space-y-3">
                              <label className="block">
                                <div className="mb-1 text-left text-sm font-semibold text-[#00ffe0]">SIM Card</div>
                                <input
                                  type="text"
                                  value={talkSimCard}
                                  onChange={(event) => setTalkSimCard(event.target.value)}
                                  className="w-full rounded-md border border-[#555] bg-[#3a3a3a] px-3 py-2 text-white outline-none"
                                />
                              </label>
                              <label className="block">
                                <div className="mb-1 text-left text-sm font-semibold text-[#00ffe0]">Channel</div>
                                <input
                                  type="number"
                                  value={talkChannel}
                                  onChange={(event) => setTalkChannel(event.target.value)}
                                  className="w-full rounded-md border border-[#555] bg-[#3a3a3a] px-3 py-2 text-white outline-none"
                                />
                              </label>
                              <label className="block">
                                <div className="mb-1 text-left text-sm font-semibold text-[#00ffe0]">WebSocket URL</div>
                                <input
                                  type="text"
                                  value={talkWsUrl}
                                  onChange={(event) => setTalkWsUrl(event.target.value)}
                                  className="w-full rounded-md border border-white bg-[#3a3a3a] px-3 py-2 text-white outline-none"
                                />
                              </label>
                              <div className="overflow-hidden rounded-full bg-white/10">
                                <div
                                  className={`h-3 transition-[width] duration-75 ${
                                    talkRealLevel < 0.2
                                      ? "bg-green-400"
                                      : talkRealLevel < 0.45
                                      ? "bg-yellow-400"
                                      : "bg-red-400"
                                  }`}
                                  style={{ width: `${Math.min(100, talkRealLevel * 200)}%` }}
                                />
                              </div>
                              <div className="grid grid-cols-2 gap-2 text-xs text-white/80">
                                <div>Session: {`${talkSimCard || focusedVehicle?.imei || "-"}-${talkChannel}`}</div>
                                <div>Sample rate: {talkSampleRate} Hz</div>
                                <div>Sent: {talkPacketCount}</div>
                                <div>Recv: {talkRecvCount}</div>
                                <div>WS: {talkWsState}</div>
                                <div>Mic: {talkMicState}</div>
                                <div>Level: {(talkRealLevel * 100).toFixed(1)}%</div>
                                <div>Status: {talkStatusMessage}</div>
                              </div>
                              <div className="max-h-40 overflow-y-auto rounded-lg bg-black/30 p-2 text-xs">
                                {talkLogs.length === 0 ? (
                                  <div className="text-white/50">No logs yet</div>
                                ) : (
                                  talkLogs.map((entry) => (
                                    <div
                                      key={entry.id}
                                      className={`border-b border-white/10 py-1 last:border-b-0 ${
                                        entry.type === "error"
                                          ? "text-red-300"
                                          : entry.type === "success"
                                          ? "text-green-300"
                                          : "text-blue-200"
                                      }`}
                                    >
                                      [{entry.timestamp}] {entry.message}
                                    </div>
                                  ))
                                )}
                              </div>
                            </div>
                            <div className="mt-4 flex items-center justify-center gap-3">
                              <button
                                type="button"
                                onClick={startTalkIntercom}
                                className="rounded-lg bg-[#14e5c3] px-5 py-2 text-base font-semibold text-[#1b1b1b] hover:bg-[#10cfb0] transition"
                              >
                                D�marrer
                              </button>
                              <button
                                type="button"
                                onClick={() => setTalkPopoverState(null)}
                                className="rounded-lg bg-[#9a3434] px-5 py-2 text-base font-semibold text-white hover:bg-[#862d2d] transition"
                              >
                                Arr�ter
                              </button>
                            </div>
                          </div>
                        )}

                        {talkPopoverState === "connecting" && (
                          <div className="absolute right-0 top-full z-[9999] mt-2 w-[220px] overflow-hidden rounded bg-[#333333] text-white shadow-lg">
                            <div className="absolute -top-2 right-[42%] h-0 w-0 border-l-8 border-r-8 border-b-8 border-l-transparent border-r-transparent border-b-[#555d66]" />
                            <div className="flex items-center justify-between bg-[#555d66] px-3 py-1.5">
                              <span className="w-4" />
                              <span className="text-sm font-semibold">Talk</span>
                              <button
                                type="button"
                                onClick={stopTalkIntercom}
                                className="text-base leading-none text-white/90 hover:text-white"
                              >
                                �
                              </button>
                            </div>
                            <div className="flex flex-col items-center px-4 py-5 text-center">
                              <div className="mb-4 h-8 w-8 animate-spin rounded-full border-2 border-white/30 border-t-white" />
                              <div className="text-xl font-semibold">{formatTalkDuration(talkElapsedSeconds)}</div>
                              <div className="mt-1 text-sm text-white">{talkStatusMessage}</div>
                            </div>
                          </div>
                        )}

                        {talkPopoverState === "active" && (
                          <div className="absolute right-0 top-full z-[9999] mt-2 w-[220px] overflow-hidden rounded bg-[#333333] text-white shadow-lg">
                            <div className="absolute -top-2 right-[42%] h-0 w-0 border-l-8 border-r-8 border-b-8 border-l-transparent border-r-transparent border-b-[#555d66]" />
                            <div className="flex items-center justify-between bg-[#555d66] px-3 py-1.5">
                              <span className="w-4" />
                              <span className="text-sm font-semibold">Talk</span>
                              <button
                                type="button"
                                onClick={stopTalkIntercom}
                                className="text-base leading-none text-white/90 hover:text-white"
                              >
                                �
                              </button>
                            </div>
                            <div className="flex flex-col items-center px-4 py-5 text-center">
                              <div className="mb-4 flex h-8 w-8 items-center justify-center rounded-full bg-[#34c759] text-lg font-bold text-white">
                                ?
                              </div>
                              <div className="text-xl font-semibold">{formatTalkDuration(talkElapsedSeconds)}</div>
                              <div className="mt-1 text-sm text-white">{talkStatusMessage}</div>
                              <div className="mt-3 h-2 w-full overflow-hidden rounded-full bg-white/10">
                                <div
                                  className={`h-full ${
                                    talkRealLevel < 0.2
                                      ? "bg-green-400"
                                      : talkRealLevel < 0.45
                                      ? "bg-yellow-400"
                                      : "bg-red-400"
                                  }`}
                                  style={{ width: `${Math.min(100, talkRealLevel * 200)}%` }}
                                />
                              </div>
                              <div className="mt-3 grid w-full grid-cols-2 gap-2 text-left text-xs text-white/80">
                                <div>Sent: {talkPacketCount}</div>
                                <div>Recv: {talkRecvCount}</div>
                                <div>WS: {talkWsState}</div>
                                <div>Mic: {talkMicState}</div>
                              </div>
                              <button
                                type="button"
                                onClick={stopTalkIntercom}
                                className="mt-4 rounded bg-[#f04d4d] px-4 py-1.5 text-sm font-medium text-white hover:bg-[#de4040] transition"
                              >
                                Stop
                              </button>
                            </div>
                          </div>
                        )}

                        {talkPopoverState === "failed" && (
                          <div className="absolute right-0 top-full z-[9999] mt-2 w-[220px] overflow-hidden rounded bg-[#333333] text-white shadow-lg">
                            <div className="absolute -top-2 right-[42%] h-0 w-0 border-l-8 border-r-8 border-b-8 border-l-transparent border-r-transparent border-b-[#555d66]" />
                            <div className="flex items-center justify-between bg-[#555d66] px-3 py-1.5">
                              <span className="w-4" />
                              <span className="text-sm font-semibold">Talk</span>
                              <button
                                type="button"
                                onClick={() => setTalkPopoverState(null)}
                                className="text-base leading-none text-white/90 hover:text-white"
                              >
                                �
                              </button>
                            </div>
                            <div className="flex flex-col items-center px-4 py-5 text-center">
                              <div className="mb-4 flex h-8 w-8 items-center justify-center rounded-full bg-[#f04d4d] text-xl font-bold text-white">
                                �
                              </div>
                              <div className="text-xl font-semibold">{formatTalkDuration(talkElapsedSeconds)}</div>
                              <div className="mt-1 text-sm text-white">{talkErrorMessage}</div>
                              <button
                                type="button"
                                onClick={startTalkIntercom}
                                className="mt-4 rounded bg-[#69c536] px-4 py-1.5 text-sm font-medium text-white hover:bg-[#5bb02d] transition"
                              >
                                Reconnect
                              </button>
                            </div>
                          </div>
                        )}
                      </div>
                      <div className="relative">
                        <button
                          type="button"
                          onClick={() => setIsLocationPopoverOpen((current) => !current)}
                          className="inline-flex items-center gap-1 rounded-md px-2 py-1.5 text-sm font-medium text-gray-700 hover:bg-gray-50 transition"
                        >
                          <MdLocationOn className="text-base" />
                          Location
                        </button>

                        {isLocationPopoverOpen && focusedVehicle && (
                          <div className="absolute right-0 top-full z-[9999] mt-2 w-[320px] overflow-hidden rounded-md border border-gray-300 bg-white shadow-xl">
                            <div className="absolute -top-2 right-[18%] h-0 w-0 border-l-8 border-r-8 border-b-8 border-l-transparent border-r-transparent border-b-white" />
                            <div className="flex items-center justify-between border-b border-gray-200 px-3 py-2">
                              <div className="min-w-0">
                                <div className="truncate text-[13px] font-semibold text-gray-700">
                                  {focusedVehicle.imei?.replace(/^it_/i, "") || focusedVehicle.plate}
                                </div>
                              </div>
                              <div className="flex items-center gap-3 text-gray-500">
                                <button
                                  type="button"
                                  onClick={() => setIsLocationModalOpen(true)}
                                  className="hover:text-gray-700"
                                >
                                  <MdFullscreen className="text-base" />
                                </button>
                                <button
                                  type="button"
                                  onClick={() => setIsLocationPopoverOpen(false)}
                                  className="text-lg leading-none hover:text-gray-700"
                                >
                                  �
                                </button>
                              </div>
                            </div>

                            <div className="relative h-[190px] overflow-hidden bg-[#eef3f9]">
                              <iframe
                                title={`Location map ${focusedVehicle.plate || focusedVehicle.imei || "vehicle"}`}
                                src={getVehicleLocationMapUrl(focusedVehicle, 17)}
                                className="h-full w-full border-0"
                                loading="lazy"
                                referrerPolicy="no-referrer-when-downgrade"
                              />
                              <div className="pointer-events-none absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/45 to-transparent px-4 py-3 text-left">
                                <div className="text-[13px] font-semibold text-white">
                                  {focusedVehicle.lastLocation || "Vehicle location"}
                                </div>
                                <div className="text-xs text-white/90">Cameroon</div>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                )}

                {displayedVehicles.length === 0 ? (
                  <div className="bg-white border border-gray-200 rounded-2xl p-6 text-center text-sm text-gray-600">
                    Aucun v�hicule trouv� dans cette zone.
                  </div>
                ) : false ? (
              /* Vue Salle de Contr?le - Toutes les cam?ras de tous les v?hicules */
              <div className="space-y-6">
                {displayedVehicles.map((vehicle) => {
                  const allChannels = vehicle.cameras?.channels || [];

                  return (
                    <div key={vehicle.id || vehicle.imei || vehicle.plate} className="bg-white rounded-2xl border shadow-sm overflow-hidden">
                      {/* Ent?te du v?hicule en mode salle de contr?le */}
                      <div className="px-4 py-3 border-b border-gray-100 bg-gray-50">
                        <div className="flex items-center justify-between">
                          <div className="min-w-0">
                            <div className="flex items-center gap-2 min-w-0">
                              <span className="font-semibold text-gray-900 truncate">
                                {vehicle.vehicleName || "V?hicule"} ??? {vehicle.plate}
                              </span>
                            </div>
                            <div className="flex items-center gap-2 mt-1 flex-wrap">
                              <span className="inline-flex items-center gap-1 bg-blue-100 text-blue-800 text-xs px-2 py-1 rounded-full">
                                <IoPersonSharp className="text-xs" /> {vehicle.driver || "N/A"}
                              </span>
                              <span className="inline-flex items-center gap-1 bg-green-100 text-green-800 text-xs px-2 py-1 rounded-full">
                                <FaMapMarkerAlt className="text-xs" /> {vehicle.lastLocation || "N/A"}
                              </span>
                            </div>
                          </div>

                          <div className="flex items-center gap-2">
                            <FaCircle className={`text-xs ${vehicle.online ? "text-green-500" : "text-gray-400"}`} />
                            <span
                              className={`text-xs px-2.5 py-1 rounded-full font-medium ${
                                vehicle.online ? "bg-green-100 text-green-800" : "bg-gray-100 text-gray-600"
                              }`}
                            >
                              {vehicle.online ? "En ligne" : "Hors ligne"}
                            </span>
                          </div>
                        </div>
                      </div>

                      {/* Toutes les cam?ras du v?hicule */}
                      <div className="p-3 bg-gray-50/60">
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3">
                          {allChannels.map((channel, index) => (
                            <div key={index} className="min-h-[200px]">
                              {renderCameraContent({
                                title: `${channel.title} ${vehicle.plate}`,
                                videoSrc: channel.videoSrc,
                                vehicleKey: vehicle.id || vehicle.imei || vehicle.plate,
                                allowLive: false,
                              })}
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            ) : isSingleVehicleFocus && focusedVehicle ? (
              <div className="bg-white rounded-2xl border border-green-200 shadow-sm overflow-visible flex flex-col">
                <div className="px-4 py-3 border-b border-gray-100 flex items-center justify-between">
                  <div className="min-w-0">
                    <div className="flex items-center gap-2 min-w-0">
                      <span className="font-semibold text-gray-900 truncate">
                        {focusedVehicle.vehicleName || "V�hicule"}
                      </span>
                      <span className="text-xs font-medium text-gray-500 truncate">
                        {focusedVehicle.plate}
                      </span>
                    </div>
                    <div className="flex items-center gap-2 flex-wrap">
                      <span className="inline-flex items-center gap-1 bg-blue-100 text-blue-800 text-xs px-2 py-1 rounded-full">
                        <IoPersonSharp className="text-xs" /> {focusedVehicle.driver || "N/A"}
                      </span>
                      <span className="inline-flex items-center gap-1 bg-green-100 text-green-800 text-xs px-2 py-1 rounded-full">
                        <FaMapMarkerAlt className="text-xs" /> {focusedVehicle.lastLocation || "N/A"}
                      </span>
                    </div>
                  </div>

                  <div className="flex items-center gap-2 shrink-0">
                    <FaCircle className={`text-xs ${focusedVehicle.online ? "text-green-500" : "text-gray-400"}`} />
                    <span
                      className={`text-xs px-2.5 py-1 rounded-full font-medium ${
                        focusedVehicle.online ? "bg-green-100 text-green-800" : "bg-gray-100 text-gray-600"
                      }`}
                    >
                      {focusedVehicle.online ? "En ligne" : "Hors ligne"}
                    </span>
                    <button
                      className="ml-2 text-gray-500 hover:text-gray-700"
                      onClick={() => setFullscreenVehicle(focusedVehicle)}
                    >
                      <MdFullscreen className="text-lg" />
                    </button>
                  </div>
                </div>

                <div className="p-3 bg-gray-50/60">
                  <div className={getFocusedLayoutWrapperClass(cameraLayout)}>
                    {getRenderableFocusedSlots(focusedVehicle, cameraLayout).map((slot, index) => (
                      <div key={slot.key} className={getFocusedLayoutItemClass(cameraLayout, index)}>
                        {renderCameraContent({
                          title: `${slot.title} ${focusedVehicle.plate}`,
                          videoSrc: slot.channel?.videoSrc,
                          vehicleKey: focusedVehicle.id || focusedVehicle.imei || focusedVehicle.plate,
                          allowLive: true,
                        })}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            ) : (
              /* Vue normale - Uniquement cam?ra avant/arri?re */
              <div className="grid grid-cols-1 md:grid-cols-2 gap-5 min-h-0">
                {displayedVehicles.map((vehicle) => {
                  const front = getChannelByType(vehicle, "front");
                  const back = getChannelByType(vehicle, "back");

                  return (
                    <div
                      key={vehicle.id || vehicle.imei || vehicle.plate}
                      role={isLive ? "button" : undefined}
                      tabIndex={isLive ? 0 : undefined}
                      onClick={() => handleVehicleCardClick(vehicle)}
                      onKeyDown={(event) => {
                        if (!isLive) return;
                        if (event.key === "Enter" || event.key === " ") {
                          event.preventDefault();
                          handleVehicleCardClick(vehicle);
                        }
                      }}
                      className={`bg-white rounded-2xl border shadow-sm overflow-hidden min-h-0 flex flex-col ${
                        vehicle.online ? "border-green-200" : "border-gray-200"
                      } ${isLive ? "cursor-pointer hover:border-[#13c2c2]" : ""}`}
                    >
                      {/* Ent?f?te v?f?hicule */}
                      <div className="px-4 py-3 border-b border-gray-100 flex items-center justify-between">
                        <div className="min-w-0">
                          <div className="flex items-center gap-2 min-w-0">
                            <span className="font-semibold text-gray-900 truncate">
                              {vehicle.vehicleName || "V?f?hicule"}
                            </span>
                            <span className="text-xs font-medium text-gray-500 truncate">
                               {vehicle.plate}
                            </span>
                          </div>
                          <div className="flex items-center gap-2 flex-wrap">
                            <span className="inline-flex items-center gap-1 bg-blue-100 text-blue-800 text-xs px-2 py-1 rounded-full">
                              <IoPersonSharp className="text-xs" /> {vehicle.driver || "N/A"}
                            </span>
                            <span className="inline-flex items-center gap-1 bg-green-100 text-green-800 text-xs px-2 py-1 rounded-full">
                              <FaMapMarkerAlt className="text-xs" /> {vehicle.lastLocation || "N/A"}
                            </span>
                          </div>
                        </div>

                        <div className="flex items-center gap-2 shrink-0">
                          <FaCircle className={`text-xs ${vehicle.online ? "text-green-500" : "text-gray-400"}`} />
                          <span
                            className={`text-xs px-2.5 py-1 rounded-full font-medium ${
                              vehicle.online ? "bg-green-100 text-green-800" : "bg-gray-100 text-gray-600"
                            }`}
                          >
                            {vehicle.online ? "En ligne" : "Hors ligne"}
                          </span>
                          <button
                            className="ml-2 text-gray-500 hover:text-gray-700"
                            onClick={() => setFullscreenVehicle(vehicle)}
                          >
                            <MdFullscreen className="text-lg" />
                          </button>
                        </div>
                      </div>

                      {/* Corps: paire de cam?f?ras */}
                      <div className="p-3 bg-gray-50/60 flex-1 min-h-0">
                        <div className={`grid min-h-0 gap-3 ${back?.videoSrc ? "grid-cols-1 lg:grid-cols-2" : "grid-cols-1"}`}>
                          <div className="min-h-[240px] sm:min-h-[260px] lg:min-h-[280px]">
                            {renderCameraContent({
                              title: `CH-1 Front  ${vehicle.plate}`,
                              videoSrc: front?.videoSrc,
                              vehicleKey: vehicle.id || vehicle.imei || vehicle.plate,
                              allowLive: false,
                            })}
                          </div>

                          {back?.videoSrc && (
                            <div className="min-h-[240px] sm:min-h-[260px] lg:min-h-[280px]">
                              {renderCameraContent({
                                title: `CH-2 Back  ${vehicle.plate}`,
                                videoSrc: back?.videoSrc,
                                vehicleKey: vehicle.id || vehicle.imei || vehicle.plate,
                                allowLive: false,
                              })}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
              </div>
            </div>
          </div>

          {/* Modale de changement de v?hicule */}
          {isChangeModalOpen && (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
              <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md mx-4 flex flex-col max-h-[90vh]">
                {/* Header modale */}
                <div className="flex items-center justify-between p-5 border-b">
                  <h3 className="text-lg font-semibold">S?lectionner un dispositif</h3>
                  <button
                    onClick={() => setIsChangeModalOpen(false)}
                    className="text-gray-400 hover:text-gray-600 text-3xl"
                  >
                    <MdClose />
                  </button>
                </div>

                {/* Recherche */}
                <div className="p-5 pt-4">
                  <div className="relative">
                    <MdSearch className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400 text-xl" />
                    <input
                      type="text"
                      placeholder="Rechercher un v?hicule ou dispositif..."
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                      className="w-full pl-12 pr-4 py-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                      autoFocus
                    />
                  </div>
                </div>

                {/* Onglets */}
                <div className="flex border-b mx-5">
                  <button className="pb-3 px-4 text-blue-600 border-b-2 border-blue-600 font-medium">Tous</button>
                  <button className="pb-3 px-4 text-gray-600 hover:text-gray-900">V?hicules</button>
                  <button className="pb-3 px-4 text-gray-600 hover:text-gray-900">Dispositifs</button>
                </div>

                {/* Liste des v?hicules */}
                <div className="overflow-y-auto flex-1">
                  {filteredVehicles.map((vehicle) => (
                    <button
                      key={vehicle.imei}
                      onClick={() => handleVehicleSelect(vehicle)}
                      className="w-full text-left px-5 py-4 hover:bg-gray-50 flex items-center justify-between border-b last:border-0 transition"
                    >
                      <div className="flex items-center gap-4">
                        <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center">
                          <MdDirectionsCar className="text-2xl text-blue-600" />
                        </div>
                        <div>
                          <div className="font-medium text-gray-900">
                            {vehicle.plate}{" "}
                            {vehicle.name && <span className="text-gray-700">{vehicle.name}</span>}
                          </div>
                          <div className="text-sm text-gray-500">
                            Plaque: {vehicle.plate}
                            <br />
                            IMEI: {vehicle.imei}
                          </div>
                          <div className="text-xs text-gray-400 mt-1 flex items-center gap-1">
                            <IoCameraSharp className="text-sm" />
                            {vehicle.cameras} cam?ras
                          </div>
                        </div>
                      </div>

                      <div className="flex items-center gap-2">
                        <FaCircle className={`text-xs ${vehicle.online ? "text-green-500" : "text-gray-400"}`} />
                        <span
                          className={`text-xs px-3 py-1 rounded-full font-medium ${
                            vehicle.online ? "bg-green-100 text-green-800" : "bg-gray-100 text-gray-600"
                          }`}
                        >
                          {vehicle.online ? "En ligne" : "Hors ligne"}
                        </span>
                      </div>
                    </button>
                  ))}
                </div>
              </div>
            </div>
          )}

          {/* Modal d'agrandissement */}
          {fullscreenVehicle && (
            <div className="fixed inset-0 bg-black bg-opacity-90 flex items-center justify-center z-50 p-4">
              <div className="bg-white rounded-2xl shadow-2xl w-full max-w-7xl max-h-[95vh] flex flex-col">
                {/* Header du modal */}
                <div className="flex items-center justify-between p-5 border-b">
                  <div className="flex items-center gap-3">
                    <MdFullscreen className="text-2xl text-gray-700" />
                    <div>
                      <h3 className="text-lg font-semibold text-gray-900">
                        {fullscreenVehicle.vehicleName || "V?hicule"} ??? {fullscreenVehicle.plate}
                      </h3>
                      <div className="flex items-center gap-2 mt-2 flex-wrap">
                        <span className="inline-flex items-center gap-1 bg-blue-100 text-blue-800 text-xs px-2.5 py-1 rounded-full">
                          <IoPersonSharp className="text-xs" /> {fullscreenVehicle.driver || "N/A"}
                        </span>
                        <span className="inline-flex items-center gap-1 bg-green-100 text-green-800 text-xs px-2.5 py-1 rounded-full">
                          <FaMapMarkerAlt className="text-xs" /> {fullscreenVehicle.lastLocation || "N/A"}
                        </span>
                      </div>
                    </div>
                  </div>
                  <button
                    onClick={() => setFullscreenVehicle(null)}
                    className="text-gray-400 hover:text-gray-600 text-2xl"
                  >
                    <MdClose />
                  </button>
                </div>

                {/* Corps du modal avec les vid?os */}
                <div className="p-5 flex-1 overflow-auto">
                  <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
                    <div className="min-h-[500px]">
                      {renderCameraContent({
                        title: `CH-1 Front  ${fullscreenVehicle.plate}`,
                        videoSrc: getChannelByType(fullscreenVehicle, "front")?.videoSrc,
                        vehicleKey: fullscreenVehicle.id || fullscreenVehicle.imei || fullscreenVehicle.plate,
                        allowLive: true,
                      })}
                    </div>

                    <div className="min-h-[500px]">
                      {renderCameraContent({
                        title: `CH-2 Back  ${fullscreenVehicle.plate}`,
                        videoSrc: getChannelByType(fullscreenVehicle, "back")?.videoSrc,
                        vehicleKey: fullscreenVehicle.id || fullscreenVehicle.imei || fullscreenVehicle.plate,
                        allowLive: true,
                      })}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {isLocationModalOpen && focusedVehicle && (
            <div className="fixed inset-0 z-[10000] flex items-center justify-center bg-black/70 p-4">
              <div className="w-full max-w-5xl overflow-hidden rounded-2xl bg-white shadow-2xl">
                <div className="flex items-center justify-between border-b border-gray-200 px-5 py-4">
                  <div>
                    <h3 className="text-lg font-semibold text-gray-900">
                      {focusedVehicle.vehicleName || "Vehicle"} {focusedVehicle.plate ? `� ${focusedVehicle.plate}` : ""}
                    </h3>
                    <p className="text-sm text-gray-500">{focusedVehicle.lastLocation || "Vehicle location"}</p>
                  </div>
                  <button
                    type="button"
                    onClick={() => setIsLocationModalOpen(false)}
                    className="text-2xl leading-none text-gray-500 hover:text-gray-700"
                  >
                    �
                  </button>
                </div>
                <iframe
                  title={`Expanded location map ${focusedVehicle.plate || focusedVehicle.imei || "vehicle"}`}
                  src={getVehicleLocationMapUrl(focusedVehicle, 18)}
                  className="h-[70vh] w-full border-0 bg-[#eef3f9]"
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                />
              </div>
            </div>
          )}

          {/* Modal Salle de Contr?le */}
          {isControlRoomModalOpen && (
            <div className="fixed inset-0 bg-black bg-opacity-90 flex items-center justify-center z-50 p-4">
              <div className="bg-white rounded-2xl shadow-2xl w-full max-w-7xl max-h-[95vh] flex flex-col">
                {/* Header du modal */}
                <div className="flex items-center justify-between p-5 border-b">
                  <div className="flex items-center gap-3">
                    <FaThLarge className="text-2xl text-gray-700" />
                    <h3 className="text-lg font-semibold text-gray-900">Salle de Contr?le</h3>
                  </div>
                  <button
                    onClick={() => setIsControlRoomModalOpen(false)}
                    className="text-gray-400 hover:text-gray-600 text-2xl"
                  >
                    <MdClose />
                  </button>
                </div>

                {/* Corps du modal avec toutes les cam?ras */}
                <div className="p-5 flex-1 overflow-auto">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    {vehiclesInZone.map((vehicle) => {
                      const allChannels = vehicle.cameras?.channels || [];

                      return (
                        <div key={vehicle.id || vehicle.imei || vehicle.plate} className="bg-white rounded-2xl border shadow-sm overflow-hidden flex flex-col">
                          {/* Ent?te du v?hicule en mode salle de contr?le */}
                          <div className="px-4 py-3 border-b border-gray-100 bg-gray-50">
                            <div className="flex items-center justify-between">
                              <div className="min-w-0">
                                <div className="flex items-center gap-2 min-w-0">
                                  <span className="font-semibold text-gray-900 truncate">
                                    {vehicle.vehicleName || "V?hicule"} ??? {vehicle.plate}
                                  </span>
                                </div>
                                <div className="flex items-center gap-2 mt-1 flex-wrap">
                                  <span className="inline-flex items-center gap-1 bg-blue-100 text-blue-800 text-xs px-2 py-1 rounded-full">
                                    <IoPersonSharp className="text-xs" /> {vehicle.driver || "N/A"}
                                  </span>
                                  <span className="inline-flex items-center gap-1 bg-green-100 text-green-800 text-xs px-2 py-1 rounded-full">
                                    <FaMapMarkerAlt className="text-xs" /> {vehicle.lastLocation || "N/A"}
                                  </span>
                                </div>
                              </div>

                              <div className="flex items-center gap-2">
                                <FaCircle className={`text-xs ${vehicle.online ? "text-green-500" : "text-gray-400"}`} />
                                <span
                                  className={`text-xs px-2.5 py-1 rounded-full font-medium ${
                                    vehicle.online ? "bg-green-100 text-green-800" : "bg-gray-100 text-gray-600"
                                  }`}
                                >
                                  {vehicle.online ? "En ligne" : "Hors ligne"}
                                </span>
                              </div>
                            </div>
                          </div>

                          {/* S?lecteur de disposition et cam?ras du v?hicule */}
                          <div className="p-3 bg-gray-50/60 flex-1 min-h-0 flex flex-col">
                            <div className="flex justify-end mb-3">
                              <CameraLayoutPicker
                                cameraLayout={vehicleLayouts[vehicle.id] || 2}
                                setCameraLayout={(layout) => setVehicleLayouts(prev => ({
                                  ...prev,
                                  [vehicle.id]: layout
                                }))}
                              />
                            </div>
                            <div className={
                              `grid gap-3 flex-1 min-h-0 ${
                                (vehicleLayouts[vehicle.id] || 2) === 1 ? 'grid-cols-1' :
                                (vehicleLayouts[vehicle.id] || 2) === 2 ? 'grid-cols-2' :
                                (vehicleLayouts[vehicle.id] || 2) === 3 ? 'grid-cols-3' :
                                'grid-cols-4'
                              }`
                            }>
                              {allChannels.map((channel, index) => (
                                <div key={index} className="min-h-[200px] flex flex-col">
                                  {renderCameraContent({
                                    title: `${channel.title} ${vehicle.plate}`,
                                    videoSrc: channel.videoSrc,
                                    vehicleKey: vehicle.id || vehicle.imei || vehicle.plate,
                                    allowLive: false,
                                  })}
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          )}

        </div>
      </Suspense>
    </>
  );
};

const DashcamPage = () => (
  <MainLayout>
    <DashcamPageContent />
  </MainLayout>
);

export default DashcamPage;





